var map = {
	"./nav-contact.png": 55727,
	"./nav-home.png": 36398,
	"./nav-library.png": 73594,
	"./nav-news.png": 56622,
	"./nav-notice.png": 51095,
	"./nav-overview.png": 74882,
	"./nav-policy.png": 78061,
	"./nav-talent.png": 77601,
	"./nav-work.png": 70884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1778;